import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { logger } from './app/core/utils/logger.util';


// Supprimer le message "Angular is running in development mode"
enableProdMode();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => logger.error(err));
